import React from 'react';
import Form from 'react-bootstrap/Form';
import { useField } from 'formik';

const Checkbox = (props) => {

    const [field, meta, helper] = useField(props);

    return (
        <Form.Group controlId={`form-${props.name}`}>
            <Form.Label>&nbsp;</Form.Label>
            <Form.Check 
                className="mt-2 mb-1" 
                id={props.name}
                name={props.name} 
                label={props.label} 
                checked={field.value || false}
                onChange={props.onChange ? props.onChange : field.onChange}
                isInvalid={!!meta.error}
                feedback={meta.error} 
                feedbackType="invalid" />
        </Form.Group>
    );

}

export default Checkbox;